export const GET_DEPARTMENTS_START = 'GET_DEPARTMENTS_START';
export const GET_DEPARTMENTS_SUCCESS = 'GET_DEPARTMENTS_SUCCESS';
export const GET_DEPARTMENTS_FAIL = 'GET_DEPARTMENTS_FAIL';

export const GET_DEPARTMENT_STATISTICS_START = 'GET_DEPARTMENT_STATISTICS_START';
export const GET_DEPARTMENT_STATISTICS_SUCCESS = 'GET_DEPARTMENT_STATISTICS_SUCCESS';
export const GET_DEPARTMENT_STATISTICS_FAIL = 'GET_DEPARTMENT_STATISTICS_FAIL';
